import React from 'react';
import { VideoPlayer } from '~/components/VideoPlayer';
import { Container, CategoryProductsMenu } from './styles';
import { PageTitle } from '~/components/PageTitle';

const CategoryHeaderIfood = () => {
  return (
    <Container>
      <CategoryProductsMenu>
        <PageTitle>Cardápio iFood</PageTitle>
        <VideoPlayer id={100} />
      </CategoryProductsMenu>
    </Container>
  );
};

export default CategoryHeaderIfood;
